import { ConcreteEncodable } from "./ConcreteEncodable";

import { OpsFiltCategoryImplEncoder } from "../../encoder/OpsFiltCategoryImplEncoder";

import * as CubiqTS from "../../index";
import { OpsFiltCategory } from "../OpsFiltCategory";

export class OpsFiltCategoryImpl extends ConcreteEncodable implements OpsFiltCategory {
  public static enType: string = "com.bcdfx.model.opsfilters.OpsFiltCategoryImpl";

  /*FID=1*/
  public filterCategoryId: string;
  /*FID=2*/
  public opsExceptionType: CubiqTS.OpsExceptionType;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = OpsFiltCategoryImplEncoder.Instance;
    this.setEncodableType(OpsFiltCategoryImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "OpsFiltCategoryImpl[" +
      "filterCategoryId=" +
      this.filterCategoryId +
      "opsExceptionType=" +
      this.opsExceptionType +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
